import React, { createContext, useCallback, useState, useContext } from 'react';

import { facebookLogin, googleLogin } from '../services/firebase';

import app from '../services/firebase';

import { apiQuser } from '../services/api';

interface SingInCredentials {
  email: string;
  password: string;
}

interface AuthContextData {
  user: object;
  singIn(credentials: SingInCredentials): Promise<void>;
  singOut(): void;
  singInFacebook(): void;
  singInGoogle(): void;
  signInProver: string, 
  setSignInProver: any,
}

interface AuthState {
  user: object;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC = ({ children }) => {
  const [signInProver, setSignInProver] = useState<string>('');
  const [data, setData] = useState<AuthState>(() => {
    const user = localStorage.getItem('@QAgil:user');

    if (user) {
      return { user: JSON.parse(user) };
    }
    return {} as AuthState;
  });

  const singIn = useCallback(async ({ email, password }) => {
    const user = await app.auth().signInWithEmailAndPassword(email, password);
    localStorage.setItem('@QAgil:user', JSON.stringify(user));

    setData({ user });
  }, []);

  const singOut = useCallback(() => {
    localStorage.removeItem('@QAgil:user');

    setData({} as AuthState);
  }, []);

  const singInFacebook = useCallback(async () => {
    setSignInProver('facebook')
    const response = await facebookLogin();
    const user = response.additionalUserInfo?.profile;
    localStorage.setItem('@QAgil:user', JSON.stringify(user));
    setData({ user } as any);
  }, []);
  

  const singInGoogle = useCallback(async () => {
    setSignInProver('google')
    const response = await googleLogin();
    const user = response.additionalUserInfo?.profile;
    localStorage.setItem('@QAgil:user', JSON.stringify(user));
    setData({ user } as any);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user: data.user, singIn, singOut, singInFacebook, singInGoogle, signInProver, setSignInProver }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvuder');
  }

  return context;
}

export { AuthProvider, useAuth };
